import PaymentMethodOption from './PaymentMethodOption';
import { PaymentMethod as PaymentMethods } from '../../../services/exports/Constants';
import CardPaymentMethod from './CardPaymentMethod';
import PaypalPaymentMethod from './PaypalPaymentMethod';

export interface PaymentMethodProps {
  id: PaymentMethods;
  name: string;
  extra: any;
  isSelected: boolean;
  isDisabled: boolean;
  onClick: () => any;
  children?: any;
  className?: string;
}

export default function PaymentMethod(props: PaymentMethodProps) {
  const { id } = props;

  const render = () =>
    ({
      [PaymentMethods.Card]: <CardPaymentMethod {...props} />,
      [PaymentMethods.Paypal]: <PaypalPaymentMethod {...props} />,
    })[id] ?? <PaymentMethodOption {...props} />;

  return render();
}
